import { render, staticRenderFns } from "./SamplesBase.vue?vue&type=template&id=fb13bedc&scoped=true"
import script from "./SamplesBase.vue?vue&type=script&lang=js"
export * from "./SamplesBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb13bedc",
  null
  
)

export default component.exports